import React from 'react';
import {Button, Card, Col, Form, Modal, ModalBody, ModalFooter, Row, Table, ButtonGroup} from '@themesberg/react-bootstrap';
import PropTypes from 'prop-types';
import label from 'enqc-utilities/src/label/Label'
import Endpoint from "enqc-utilities/src/api/Endpoint";
import {currencyFormat, isEmpty, isResponseOk} from "enqc-utilities/src/utils/Utilities";
import TextInput from "./input/TextInput";
import {faBuilding, faTrash} from "@fortawesome/free-solid-svg-icons";
import {CURRENCY_SYMBOL} from "../utils/Global";
import ItemOption from "./input/ItemOption";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import BaseComponent, {toasting} from "../pages/base/BaseComponent";
import WarningLabel from "./input/WarningLabel";
import SpotLocationSelectionModal from "./input/SpotLocationSelectionModal";

/*= (message, okCallback, cancelCallback) =>*/

export default class NewProductOrderInquiryModal extends BaseComponent {

    constructor(props){
        super(props);
        let validation = this.defaultValidation()
        let validationMessage = this.defaultValidationMessage()
        let defaultProduct = props.defaultProduct?props.defaultProduct:{}
        let disableProductSelection = defaultProduct.id?true:false
        this.state = {
            show:false,
            company: props.company?props.company:{},
            products:[],
            productPackages:[],
            orderItems:[],
            selectedProduct:defaultProduct,
            disableProductSelection:disableProductSelection,
            selectedProductPackage:{},
            companyName:"",
            validation,
            validationMessage,
            spotLocationSelectionModal:false,
            selectedSpotLocation:{},
            paymentAttribute:{}
        }
    }

    defaultValidation = () =>{
        let validation = {};
        validation.company = false ;
        validation.product = false ;
        validation.productPackage = false ;
        validation.orderItems = false ;
        return validation ;
    }
    defaultValidationMessage = () =>{
        let validationMessage = {};
        validationMessage.company = "" ;
        validationMessage.product = "" ;
        validationMessage.productPackage = "" ;
        validationMessage.orderItems = "" ;
        return validationMessage ;
    }
    componentDidMount() {
        super.componentDidMount();
        this.fetchPaymentMediaAttribute((paymentAttribute)=>{
            this.setState({paymentAttribute})
        })
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps!=this.props){
            let show = this.props.show?this.props.show:false
            this.setState({show},() => {
                if(show && !prevState.show){
                    let validation = this.defaultValidation()
                    let validationMessage = this.defaultValidationMessage()
                    let defaultProduct = this.props.defaultProduct?this.props.defaultProduct:{}
                    let disableProductSelection = defaultProduct.id?true:false
                    this.setState({
                        show:show,
                        company:this.props.company?this.props.company:{},
                        selectedProduct:defaultProduct,
                        disableProductSelection:disableProductSelection,
                        selectedProductPackage:{},
                        orderItems:[],
                        validation,
                        validationMessage
                    }, () => {
                        this.fetchProducts()
                    })
                }
            })
        }
    }

    fetchProducts = () => {
        let {selectedProduct} = this.state
        this.get(Endpoint.API.PRODUCTS, {
            params:{
                ascending:true,
                sortir:"suggestion",
            }
        }, null, response=>{
            if(response.code === 200){
                this.setState({
                    products : response.data
                }, () => {
                    if(!isEmpty(selectedProduct)){
                        this.fetchProductPackages()
                    }
                })
            }
        }, true, true);
    }

    fetchProductPackages(){
        let {selectedProduct} = this.state
        this.get(Endpoint.API.PRODUCT_PACKAGES, {params:{"published":true, productId:selectedProduct.id}},null, (response)=>{
            if(isResponseOk(response)){
                this.setState({
                    productPackages : response.data
                })
            }
        },   false, false)
    }

    fetchPaymentMediaAttribute(callback){
        this.get(Endpoint.API.PAYMENT_MEDIA_ATTRIBUTE, {},null, (response)=>{
            if(isResponseOk(response)){
                callback(response.data)
            }
        },   false, false)
    }

    validate(callback){
        let {company, selectedProduct, selectedProductPackage, validation, validationMessage} = this.state
        let valid = true;
        validation = this.defaultValidation()
        validationMessage = this.defaultValidationMessage()
        if (isEmpty(company)) {
            validation.company = true
            validationMessage.company = label.PleaseSelectCompany
            valid = false;
        }
        if (isEmpty(selectedProduct)) {
            validation.product = true
            validationMessage.product = label.PleaseSelectProduct
            valid = false;
        }
        if (isEmpty(selectedProductPackage) ) {
            validation.productPackage = true
            validationMessage.productPackage = label.PleaseSelectPackage
            valid = false;
        }
        this.setState({validation, validationMessage}, () => {
            callback(valid)
        })

    }


    validateFormSubmit() {
        // await super.validateFormSubmit();
        let {show, company, selectedProduct, selectedProductPackage, selectedSpotLocation,
            products, productPackages, orderItems, spotLocationSelectionModal, paymentAttribute,
            validation, validationMessage} = this.state
        let valid = true;
        validation = this.defaultValidation()
        validationMessage = this.defaultValidationMessage()
        if (isEmpty(company)) {
            validation.company = true
            validationMessage.company = label.PleaseSelectCompany
            valid = false;
        }
        if (isEmpty(selectedProduct)) {
            validation.product = true
            validationMessage.product = label.PleaseSelectProduct
            valid = false;
        }
        if (isEmpty(selectedProductPackage) ) {
            validation.productPackage = true
            validationMessage.productPackage = label.PleaseSelectPackage
            valid = false;
        }

        if (isEmpty(orderItems) || orderItems.length===0) {
            validation.orderItems = true
            validationMessage.orderItems = label.PleaseAddAtLeastOneOrderItem
            valid = false;
        }
        this.setState({validation, validationMessage}, () => {
            if(valid){
                this.submit()
            }
        })
    }

    submit(){
        let {show, company, selectedProduct, selectedProductPackage, selectedSpotLocation,
            products, productPackages, orderItems, spotLocationSelectionModal, paymentAttribute,
            validation, validationMessage} = this.state
        let {onCreateOrder, onClose} = this.props
        let form = new FormData()
        form.append("orderItemListGson", JSON.stringify(orderItems))
        this.props.showProcessing()
        this.post(Endpoint.API.PRODUCT_ORDER_CREATE_WITH_COMPANY+"/"+company.id, form, null, (res)=>{
            this.props.closeProcessing()
            if(isResponseOk(res)){
                let productOrder = res.data
                toasting.success(label.SucceedCreatingNewRegistration)
                if(onCreateOrder){
                    onCreateOrder(productOrder)
                }
            }else{
                toasting.error(res.message)
                if(onClose){
                    onClose()
                }
            }
        }, true, false)
    }

    render(){
        let {show, company, selectedProduct, selectedProductPackage, selectedSpotLocation, disableProductSelection,
            products, productPackages, orderItems, spotLocationSelectionModal, paymentAttribute,
            validation, validationMessage} = this.state
        let {onClose} = this.props

        let adminFee = paymentAttribute.adminFee?paymentAttribute.adminFee:0
        let taxPercent = paymentAttribute.taxPercent?paymentAttribute.taxPercent:0
        let taxAmount = 0
        let total = 0
        let totalAmount = 0
        orderItems.forEach((item)=>{
            let productPackage = item.productPackage
            total += productPackage.price
        })
        // total = total+adminFee
        taxAmount = (total+adminFee)*(taxPercent/100)
        totalAmount = total+taxAmount+adminFee

        return (
            <>
                <SpotLocationSelectionModal
                    showing={spotLocationSelectionModal}
                    showProcessing={this.props.showProcessing}
                    closeProcessing={this.props.closeProcessing}
                    company={company}
                    onClose={()=>{
                        this.setState({spotLocationSelectionModal:false})
                    }}
                    onSelect={(spotLocation)=>{
                        let orderItem = {}
                        orderItem.productPackage = selectedProductPackage
                        orderItem.spotLocation = spotLocation
                        orderItems.push(orderItem)
                        this.setState({spotLocationSelectionModal:false, orderItems})
                    }}/>
                <Modal
                    size="xl"
                    as={Modal.Dialog}
                    show={show}
                    centered={true}
                    backdrop={true}>
                    {super.render()}
                    <Modal.Header>
                        {label.CreateNewOrder}
                    </Modal.Header>
                    <ModalBody>
                        <Row>
                            <Col>
                                <TextInput
                                    label={label.Company}
                                    icon={faBuilding}
                                    placeholder={company.fullName}
                                    value={company.fullName}
                                />
                            </Col>
                            <Col>
                                <ItemOption
                                    size="sm"
                                    label={label.SelectProduct}
                                    disable={disableProductSelection}
                                    fieldForLabel={"name"}
                                    objects={products}
                                    value={selectedProduct}
                                    callback={(product) => {
                                        validation.product = false
                                        validationMessage.product = ""
                                        this.setState({
                                            validation: validation,
                                            validationMessage:validationMessage,
                                            selectedProduct:product
                                        }, () => {
                                            if(product.id){
                                                this.fetchProductPackages()
                                            }
                                        })
                                    }}
                                    isError={validation.product}
                                    errorMessage={validationMessage.product}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <ItemOption
                                    size="sm"
                                    label={label.ProductPackage}
                                    fieldForLabel={"name"}
                                    objects={productPackages}
                                    value={selectedProductPackage}
                                    callback={(productPackage) => {
                                        validation.productPackage = false
                                        validationMessage.productPackage = ""
                                        this.setState({
                                            validation: validation,
                                            validationMessage:validationMessage,
                                            selectedProductPackage:productPackage
                                        })
                                    }}
                                    isError={validation.productPackage}
                                    errorMessage={validationMessage.productPackage}
                                />
                            </Col>
                            <Col>
                                <TextInput
                                    label={label.Description}
                                    value={selectedProductPackage.description}
                                    readOnly={true}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <TextInput
                                    label={label.MonthlyPeriod}
                                    value={selectedProductPackage.monthPeriod}
                                    readOnly={true}
                                />
                            </Col>
                            <Col md={4}>
                                <TextInput
                                    label={label.Price}
                                    value={currencyFormat(selectedProductPackage.price, 'Rp')}
                                    readOnly={true}
                                />
                            </Col>
                            <Col md={2} className="text-right">
                                <Form.Group>
                                    <Form.Label>&nbsp;&nbsp;</Form.Label>
                                    <br/>
                                    <Button
                                        block
                                        color="warning"
                                        onClick={e=>{
                                            this.validate((valid)=>{
                                                if(valid){
                                                    this.setState({spotLocationSelectionModal:true})
                                                }
                                            })
                                        }}>
                                        {label.Add}
                                    </Button>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Card>
                                    <Card.Body className="p-0">
                                        <Table hover responsive>
                                            <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>{label.Product}</th>
                                                <th>{label.ProductPackage}</th>
                                                <th>{label.Description}</th>
                                                <th>{label.MonthPeriod}</th>
                                                <th style={{maxWidth:'210px'}}>{label.Location}</th>
                                                <th>{label.Price}</th>
                                                <th>{label.Remove}</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {
                                                orderItems.map((item, index) => (
                                                    <>
                                                        <tr key={item.id}>
                                                            <th scope="row">{index+1}</th>
                                                            <td>{item.productPackage.product.name}</td>
                                                            <td>{item.productPackage.name}</td>
                                                            <td>{item.productPackage.description}</td>
                                                            <td>{item.productPackage.monthPeriod+" "+label.Month}</td>
                                                            <td style={{maxWidth:'210px'}} className="text-wrap">{item.spotLocation?item.spotLocation.fullAddress:""}</td>
                                                            <td>
                                                                {currencyFormat(item.productPackage.price, CURRENCY_SYMBOL)}
                                                            </td>
                                                            <td>
                                                                <Button
                                                                    size="sm"
                                                                    className="btn-danger"
                                                                    onClick={() => {
                                                                        orderItems.splice(index, 1)
                                                                        this.setState({orderItems})
                                                                    }}>
                                                                    <FontAwesomeIcon icon={faTrash} />
                                                                </Button>
                                                            </td>
                                                        </tr>
                                                        {
                                                            index===orderItems.length-1?(
                                                                <>
                                                                    <tr>
                                                                        <th></th>
                                                                        <td></td>
                                                                        <td></td>
                                                                        <td></td>
                                                                        <td><h6>{label.AdminFee}</h6></td>
                                                                        <td><h6>{currencyFormat(adminFee, 'Rp')}</h6></td>
                                                                        <td></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th></th>
                                                                        <td></td>
                                                                        <td></td>
                                                                        <td></td>
                                                                        <td><h6>{label.Tax}</h6></td>
                                                                        <td><h6>{currencyFormat(taxAmount, 'Rp')}</h6></td>
                                                                        <td></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th></th>
                                                                        <td></td>
                                                                        <td></td>
                                                                        <td></td>
                                                                        <td><h5>{label.Total}</h5></td>
                                                                        <td><h5>{currencyFormat(totalAmount, 'Rp')}</h5></td>
                                                                        <td></td>
                                                                    </tr>
                                                                </>
                                                            ):null
                                                        }
                                                    </>
                                                ))
                                            }
                                            </tbody>
                                        </Table>
                                        <WarningLabel show={validation.orderItems} message={validationMessage.orderItems} />
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <ButtonGroup>
                            <Button
                                variant="warning"
                                onClick={e=>{
                                e.preventDefault()
                                this.setState({
                                    modal:false
                                }, () => {
                                    if(this.props.onClose!=null){
                                        this.props.onClose()
                                    }
                                })
                            }}>
                                {label.Cancel}
                            </Button>
                            &nbsp;
                            <Button
                                variant="success"
                                onClick={e=>{
                                e.preventDefault()
                                this.validateFormSubmit()
                            }}>
                                {label.CreateOrder}
                            </Button>
                        </ButtonGroup>
                    </ModalFooter>
                </Modal>
            </>
        )
    }
}

NewProductOrderInquiryModal.propTypes = {
    defaultProduct:PropTypes.object,
    show:PropTypes.bool.isRequired,
    company:PropTypes.object.isRequired,
    onClose:PropTypes.func.isRequired,
    onCreateOrder:PropTypes.func.isRequired
}
